import React from 'react';
import {SpanIcon} from '@mazraeapp/react_icon_kit';
import classNames from 'classnames';
import EmptyImg from '../../../../assets/image/shared/empty.svg';

import {useNavigate} from 'react-router-dom';
import {CodeToInputGroupName, timeFromCreated} from './helper';

interface MySaleCardProps {
  data: IUserListLikedData;
}
const MySaleCard = ({data}: MySaleCardProps) => {
  const navigate = useNavigate();

  return (
    <div
      className="w-full  px-2 gap-3 bg-white items-center h-[128px] flex rounded-[8px] shadow-sm relative py-2 my-2"
      onClick={() =>
        data?.post?.input_group?.code &&
        navigate(
          `/category-card-detail/${
            CodeToInputGroupName[data.post.input_group?.code]
          }/${data.post.id}`,
        )
      }
    >
      {data.post.main_image ? (
        <div>
          <img
            className="rounded-[8px] min-w-[112px] h-[112px]"
            width={112}
            height={112}
            src={data.post.main_image}
            alt={data.post.title}
          />
        </div>
      ) : (
        <div className="flex items-center justify-center w-[112px] h-[112px] rounded-[8px] min-w-[112px] bg-gray-100">
          <img width={50} height={50} src={EmptyImg} alt={data.post.title} />
        </div>
      )}

      <div className="w-full flex flex-col h-full justify-between py-2 px-2">
        {data.post.store ? (
          <div className="flex flex-col gap-2">
            <span className="text-[#1A1A1A] text-md font-Medium">
              {data.post.title}
            </span>
            <div className="flex gap-1 items-center justify-between w-full text-sm text-gray-700 font-Regular">
              <div className="items-center flex gap-2">
                <SpanIcon className="icon-nameStore text-md" />
                <span className="text-ellipsis w-[120px] overflow-hidden text-nowrap	">
                  {data.post.store.title}
                </span>
              </div>
            </div>
          </div>
        ) : (
          <>
            <div className="flex flex-col gap-2">
              <span className="text-[#1A1A1A] text-md font-Medium">
                {data.post.title}
              </span>
              <div className="flex gap-1 items-center text-sm text-gray-700 font-Regular">
                <SpanIcon className="icon-nameLocation text-xl" />
                <span>
                  {data.post.state?.name || ''} . {data.post.city?.name || ''}
                </span>
              </div>
            </div>
          </>
        )}

        <div className="w-full flex justify-between items-center">
          <span
            className={classNames('text-xs font-Regular flex items-center')}
          >
            {data.post.published_at && timeFromCreated(data.post.published_at)}
          </span>

          <div className='text-[#1A1A1A] text-md font-Medium"'>
            {data?.post?.ad_price && (
              <>
                {data?.post?.ad_price}
                <span className="text-xs">تومان</span>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MySaleCard;
